<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      show-cancel-button
    >
      <div>
        <div class="main">
          <div class="content" ref="content">
            <div v-html="content"></div>
          </div>
        </div>
        <div class="btnWrap">
          <div
            class="sureBtn"
            @click="goOk"
          >
            我已阅读
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* global http protocol */
export default {
  data() {
    return {
      show: false,
      title: null,
      content: null
    }
  },
  methods: {
    showDia(id) {
      protocol.param_getContentDetails.param.id = id
      http.getRes(protocol.param_getContentDetails).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.title = value.title
          this.content = value.content
          this.show = true
          this.$nextTick(() => {
            this.$refs.content.scrollTop = 0
          })
        } else {
          this.$toast(message)
        }
      })
    },
    goFalse() {
      this.show = false
    },
    goOk() {
      this.show = false
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 912px;
  background-color: #1A1A1A !important;
  border-radius: 8px;
  border: 1px solid #545454;
  padding: 48px 42px;
  * {
    font-family: Source Han Sans SC;
    font-weight: 200;
    font-size: 14px;
    color: #DFDFDF;
  }
  .el-dialog__header {
    text-align: center;
    padding: 0;
    padding-bottom: 28px;
    .el-dialog__title {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF !important;
    }
    .el-dialog__close {
      font-size: 18px;
      color: #999999;
    }
  }
  .main {
    height: 402px;
    box-sizing: border-box;
    border: 1px solid #545454;
    border-radius: 8px;
    padding: 18px 20px 42px;
    .content {
      overflow-y: scroll;
      height: 340px;
      &::-webkit-scrollbar {
        width: 0;
      }
      .contentTitle {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 20px;
      }
    }
  }
  .btnWrap {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    .sureBtn {
      width: 100px;
      height: 24px;
      line-height: 24px;
      background: #272727;
      border-radius: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #DFDFDF;
      text-align: center;
      cursor: pointer;
    }
  }
}

</style>
